import React from "react";
import MaterialButton, {
  ButtonProps as MaterialButtonProps
} from "@material-ui/core/Button";

import { Box, BoxProps } from "rebass";
interface ButtonBaseProps {
  variant?: string;
  isPrimary?: boolean;
}

type ButtonProps = ButtonBaseProps & BoxProps & MaterialButtonProps;

const ButtonBase = (props: any) => {

  return <MaterialButton {...props} variant="contained"/>;
};

export default ButtonBase;

ButtonBase.defaultProps = {
  variant: "contained",
  my: 12,
};
